<template>  
  <v-layout row wprap>
    <v-flex xs12 py-4 pr-4 pl-2 style="position:relative;" >
      <v-card class="ma-2 maincontent" :color="dhover?'primary lighten-5':''" @dragover.prevent="dhover = $event.dataTransfer.effectAllowed == 'all'" @dragleave.prevent="dhover=false" @drop.prevent="onDocumentsAdded(Array.from($event.dataTransfer.files))" >
        <v-card-title style="flex-direction:column;align-items:stretch;height:100%;" >
             <span class="subheading d-flex" style="flex:0 0 auto;">{{coriolis?$t('Pilot.Coriolis.UploadTitle'):$t('Pilot.FileUpload.Title')}} <v-spacer /><v-btn  class="flex-grow-0 " small :title="$t('Pilot.FileUpload.AddFiles')" color="primary" icon style="position:relative;"><v-icon>mdi-plus</v-icon><input type="file" accept=".gz,.json" ref="fileInputs" class="docInput" multiple label="File input" @change="onDocumentsAdded(Array.from($event.target.files))" /></v-btn></span>                                   
             <div style="flex:0 0 auto;">
                <v-btn class="flex-grow-0" v-if="hasClearable" small @click="clearAll()">{{$t('Pilot.FileUpload.ClearAll')}} <v-icon right>mdi-recycle</v-icon></v-btn>
                <v-btn class="flex-grow-0" v-if="hasDeletable" small @click="removeAllError()">{{$t('Pilot.FileUpload.DeleteError')}} <v-icon right>mdi-delete</v-icon></v-btn>
                <v-btn class="flex-grow-0" v-if="hasRetry" small @click="retryAll()">{{$t('Pilot.FileUpload.RetryAll')}} <v-icon right>mdi-refresh</v-icon></v-btn>                
                <v-btn class="flex-grow-0" v-if="hasUpload" small @click="uploadAll()">{{$t('Pilot.FileUpload.UploadAll')}} <v-icon right>mdi-upload</v-icon></v-btn>                
             </div>
              <v-layout row wrap mt-2 style="flex:0 0 auto;" >
                <v-flex class="cell" xs12><span class="body-2">{{$t('Pilot.FileUpload.Name')}}</span></v-flex>                                
              </v-layout>              
              <v-layout row wrap style="flex:1 0;overflow:auto;align-content:flex-start;">                
                <template v-for="(fileinfo,idx) in filesToUpload">
                  <v-flex class="cell" :key="`n_${idx}`" xs8 pr-2>                    
                    <v-icon v-if="!fileinfo.analysis.isValidFilename" class="mr-2" color="red lighten-3" :title="fileinfo.analysis.errorDigest">mdi-file-cancel-outline</v-icon>                      
                    <v-icon v-else-if="fileinfo.status == 'success'" class="mr-2" color="green">mdi-file-check-outline</v-icon> 
                    <v-icon v-else-if="fileinfo.status == 'error'"  class="mr-2" color="red">mdi-file-remove-outline</v-icon> 
                    <template v-else>
                      <v-icon v-if="isUploadable(fileinfo) || fileinfo.status == 'uploading'" class="mr-2">mdi-file-move-outline</v-icon>                                         
                      <v-icon v-else class="mr-2" color="orange lighten-3" :title="$t('Pilot.FileUpload.NotCurrentMission')">mdi-file-cancel-outline</v-icon>                                            
                    </template>                    
                    {{fileinfo.file.name}} ({{fileinfo.file.size | formatBytes}})</v-flex>
                  <v-flex class="cell rightcontent" :key="`a_${idx}`" xs4 pl-2 >                                      
                    <template v-if="fileinfo.analysis.isValidFilename">
                      <v-btn small icon v-if="isUploadable(fileinfo)" @click="uploadFile(fileinfo)" :title="$t('Pilot.FileUpload.UploadTooltip')">
                        <v-icon>mdi-upload</v-icon>
                      </v-btn>
                      <v-progress-circular v-if="fileinfo.status == 'uploading'"  :rotate="360" color="primary" :size="30" :width="4" :value="fileinfo.progress">{{ fileinfo.progress }}</v-progress-circular>
                      <!--<v-progress-circular  v-if="fileinfo.status == 'uploading'" :rotate="360" indeterminate color="primary" :size="30" :width="4"></v-progress-circular>-->
                    </template>
                    <v-btn small icon v-if="fileinfo.status != 'uploading'" @click="deleteFile(fileinfo)"  :title="$t('Pilot.FileUpload.RemoveTooltip')">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>                
                  </v-flex>                                             
                </template>
                <template v-for="file in fileList">
                  <v-flex class="cell" xs8 pr-2 :key="`n_${file}`">
                    <v-icon class="mr-2" color="green">mdi-file-check-outline</v-icon> 
                    {{file}}
                  </v-flex>  
                  <v-flex class="cell rightcontent" :key="`a_${file}`" xs4 pl-2 >
                    <v-btn small icon  @click="downloadFile(file)" :title="$t('Pilot.FileUpload.DownloadTooltip')">
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                      <v-btn small icon @click="deleteListFile(file)"  :title="$t('Pilot.FileUpload.RemoveTooltip')">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn> 
                  </v-flex>
                </template>
              </v-layout>                       
        </v-card-title>
      </v-card>      
    </v-flex>    
     <v-dialog
      v-model="analysing"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{$t('Pilot.FileUpload.AnalyseFile')}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script lang="ts">

  import Vue from 'vue'  
  //@ts-ignore 
  import draggable from 'vuedraggable'  
  import deepEqual from 'deep-equal'  
  import Component from 'vue-class-component'
  import sortBy from 'lodash/sortBy'
  import types from '@/store/all-mutation-types'
  import { Watch} from 'vue-property-decorator'  
  import {buildDataMissionKey, DataPoolMissionKeys} from '@/enum/DataPool'
  import { GliderFileType } from '@/enum/GliderFileType'
  import { IFileTransfertConfig } from '@/models/iris/fileTransfert/IFileTransfertConfig'
  import { MissionUi } from '@/models/ui/MissionUi'
  import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
  import { AloGliderFileShort } from '../../models/alo/AloGliderFileShort'
  import apiHelpers, { directPayloadQuery } from '@/utils/api'
  import mission from '../../api/mission';
  import { SecurityItemsKeys } from '../../enum/SecurityItems';
  import { VuetifyConfirmObject } from 'vuetify-confirm'
  import {IFileUpload} from '@/models/ui/IFileUpload'
  import apiMission from '@/api/mission'
import { toStringDictionary } from '@/utils/groupBy'
import { UploadStatus } from '@/enum/UploadStatus'
import { AloGliderFileListReport } from '@/models/alo/AloGliderFileListReport'
import Stroke from 'ol/style/Stroke'
import { AxiosProgressEvent } from 'axios'

@Component({
    name: 'MissionDetailFileUpload',
    components:{draggable},
    props:{
      filterCurrentMission:{
        type:Boolean,
        default:true
      },
      coriolis:{
        type:Boolean,
        default:false
      },
      fileList:{
        type:Array,
        default:[]
      }
    }    
  })
  export default class MissionDetailFileUpload extends Vue {  
   
    fileList!:Array<string>
    filesToUpload:Array<IFileUpload> = []  
    coriolis!:boolean
    dhover = false
    analysing = false
    filterCurrentMission!:boolean

    get currentDetailMission(){
      return this.$store.myGetters.currentDetailMission
    }

    get mission() {
        return this.currentDetailMission.mission
    }            

    created() {                  
    }

    @Watch('mission')
    onMissionChanged(newValue: any) {                   
      
    }

    onDocumentsAdded(files:File[]){               
      this.dhover = false           
      if(files.length > 0){          
          const newFiles = files.filter(f => ((!this.coriolis && f.type == 'application/x-gzip') || f.type == 'application/json') &&  this.filesToUpload.every(fu => fu.file.name != f.name) ).map(f => {              
            const it = {file:f,progress:0,status:UploadStatus.waiting}                  
            return it
          })
          if(newFiles.length > 0) {
            this.analysing = true
            directPayloadQuery(this.coriolis?apiMission.postCoriolisFileList:apiMission.postFileList,newFiles.map(f => f.file.name)).then((r)=>{                        
              const dicFileResult = toStringDictionary(r.fileResults,f => f.fileName)            
              this.filesToUpload.push(...newFiles.map(f => ({...f,analysis:dicFileResult[f.file.name] })))                    
            }).finally(()=>{
              this.analysing = false
            })
          }          
      }      
      //@ts-ignore
      this.$refs.fileInputs.value = null
    }  

    uploadAll(){
      this.doUploadFile(this.filesToUpload)
    }

    retryAll(){
      this.doUploadFile(this.filesToUpload.filter(f => f.status == UploadStatus.error))
    }
    
    uploadFile(fileInfo:IFileUpload) {
      this.doUploadFile([fileInfo])
    }

    doUploadFile(filesToUpload:Array<IFileUpload>) {                          
      const uploadPromises = filesToUpload.filter(this.isUploadable).map(fileToUpload => {      
          fileToUpload.status = UploadStatus.uploading
          fileToUpload.progress = 1        
          return directPayloadQuery(this.coriolis?apiMission.uploadCoriolisFile:apiMission.uploadFile,
                            {                                             
                              file:fileToUpload.file,
                              misId:this.coriolis?this.mission.misId:undefined,                              
                              progress:(e:AxiosProgressEvent)=>{
                                if(e.total) fileToUpload.progress =  Math.round( ( e.loaded / e.total ) * 100 )                        
                              }
                            }).then(result => {  
                                fileToUpload.progress = 100
                                fileToUpload.status = UploadStatus.success
                                if(result.fileResults?.length ??0 > 0) {
                                  fileToUpload.analysis = result.fileResults[0]                            
                                }                                
                                if(this.coriolis){
                                  this.$emit('uploaded', fileToUpload.file.name)
                                  this.deleteFile(fileToUpload)
                                }
                              }).catch(error =>{
                                fileToUpload.status = UploadStatus.error
                              })
      })
      Promise.all(uploadPromises).finally(()=>{
        this.$emit('allUploaded')
      })
  }
    
    clearAll(){
      this.filesToUpload = this.filesToUpload.filter(f => f.status == UploadStatus.uploading)
    }

    removeAllError(){
      this.filesToUpload = this.filesToUpload.filter(f => f.analysis.isValidFilename)
    }

    get hasUpload(){
      return this.filesToUpload.some(this.isUploadable)
    }

    isUploadable(fileInfo:IFileUpload) {
      return (fileInfo.status == UploadStatus.waiting || fileInfo.status == UploadStatus.error) && fileInfo.analysis.isValidFilename && (!this.filterCurrentMission || fileInfo.analysis.misId == this.mission.misId)
    }

    get hasDeletable(){
      return this.filesToUpload.some(f => (!f.analysis.isValidFilename))
    }    

     get hasClearable(){
      return this.filesToUpload.some(f => (f.status != UploadStatus.uploading))
     }   

     get hasRetry(){
      return this.filesToUpload.some(f => (f.status == UploadStatus.error))
     }
    
    

    deleteFile(fileInfo:IFileUpload){      
      const idx = this.filesToUpload.findIndex(f => f.file.name == fileInfo.file.name)
      if(idx > -1) this.filesToUpload.splice(idx,1)
    }


    deleteListFile(file:string) {
      this.$emit("delete",file)      
    }

    
    downloadFile(file:string) {
      this.$emit("download",file)      
    }  

    mounted() {                 
    }
     
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
  .subheading,.body-2{
    font-weight: bold;  
  }

  .cell{
    border-bottom: 1px solid #ccc;        
    min-height: 41px;
    display: flex;
    align-items: center;
  }

  .rightcontent{    
    
    justify-content: end;
    text-align: right;    
  }


  
  .docInput{
    position:absolute!important;
    opacity: 0;
    width: 100%!important;
    height: 100%!important;
    display: block!important;
    top:0px!important;
    left: 0px!important;
    padding: 0px!important;
    margin: 0px!important;
    z-index: 1;
    cursor: pointer;
  }
</style>
